import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import { endPoints, GA, PLATFORM } from '../../constants'
// import Footer from '../../components/Footer'
import { setWindowGA } from '../../helpers/DTM'
// import arrowLogo from '../../asset/arrow.png'
import {
	VoteWrapper,
	Main,
	MaxWidth,
	HexButton,
	HexParent,
	HexButtonText,
	Question,
	// ButtonWrap,
	// ArrowImg,
	OptionsWrapper,
	Line,
} from './styles'
import {
	getQuestions,
	getUserSubmission,
	saveQuizAnswer,
} from '../../redux/slices/votes'
import { APIMethods, ReqBodyWithHeaders } from '../../types/state'
import { useTransition, animated } from 'react-spring'
import CountDownTimer from '../../components/CountDownTimer'
// import WrapperButton from '../../components/WrapperButton'
import Footer from '../../components/Footer'

const Votes = () => {
	const dispatch = useDispatch()
	const votesData = useSelector((state: RootState) => state.votes)
	const metaData = useSelector((state: RootState) => state.meta)
	const userData = useSelector((state: RootState) => state.user)
	const selectedLanguage = useSelector(
		(state: RootState) => state.translations.selectedLanguage
	)

	const [selectedOption, setSelectedOption] = useState({
		optionId: '0',
		option: '',
	})

	const [isLoaded, setIsLoaded] = useState(false)
	const [timerStatus, setTimerStatus] = useState(false)
	const transition = useTransition(isLoaded, {
		from: { x: 0, y: 950, opacity: 0, delay: 450 },
		enter: { x: 0, y: 0, opacity: 1, delay: 450 },
		leave: { x: 0, y: 950, opacity: 0, delay: 450 },
	})

	const startTimer = () => {
		setTimerStatus(true)
	}

	const handleTimer = () => {
		setTimerStatus(false)
		onSubmit() //comment this if not want submit answer after 45sec
	}

	const handleSelectedOption = (item: {
		optionId: string
		option: string
	}) => {
		const optionObj = {
			optionId: item.optionId,
			option: item.option,
		}
		setSelectedOption(optionObj)
	}

	const onSubmit = () => {
		sendGA()
		sendCT()
		const obj: ReqBodyWithHeaders = {
			sessionId: userData.sessionId,
			method: APIMethods.POST,
			url: endPoints.submitQuizAnswers,
			client: 'desktop',
			phoneNumber: `+91${userData.phone}`,
			platformName: PLATFORM,
			timelineId: userData.timelineId,
			submissions: [
				{
					questionId: votesData.questionData.id,
					optionIds: [selectedOption.optionId],
				},
			],
		}
		dispatch(saveQuizAnswer(obj))
	}

	useEffect(() => {
		const obj: ReqBodyWithHeaders = {
			sessionId: userData.sessionId,
			method: APIMethods.POST,
			url: endPoints.checkuserSubmission,
			client: 'desktop',
			platformName: PLATFORM,
			timelineId: userData.timelineId,
			phoneNumber: `+91${userData.phone}`,
		}
		if (userData.timelineId) {
			dispatch(getUserSubmission(obj))
		}
	}, [userData.timelineId])

	useEffect(() => {
		// document.body.style.margin = '0'
		const platformName = PLATFORM
		if (!votesData.alreadyParticipated) {
			const obj: ReqBodyWithHeaders = {
				sessionId: userData.sessionId,
				method: APIMethods.GET,
				url: endPoints.activeQuestion
					.replace('{platformName}', platformName)
					.replace('{timelineId}', userData.timelineId),
				client: 'desktop',
			}

			dispatch(getQuestions(obj))
		}
	}, [votesData.alreadyParticipated])

	useEffect(() => {
		setIsLoaded(true)
	}, [votesData.questionData])

	const sendGA = () => {
		const data = {
			event: GA.eventName,
			pageName: GA.votingPage,
			mobile: btoa(userData.phone.toString()),
			pageURL: window.location.href + '/votes',
			customerID: userData.id,
			lkUserType: userData.hasPlacedOrder ? 'lkRepeat' : 'lkNew',
			loginStatus: metaData.isLogin,
			platform: metaData.platform,
		}
		setWindowGA(data)
	}

	const sendCT = () => {
		window.clevertap.event.push('Pages Viewed', {
			'Page Name': GA.votingPage,
			Phone: userData.phone,
		})
	}

	useEffect(() => {
		// countdownTimeStart()
		startTimer()
	}, [
		// countdownTimeStart,
		dispatch,
		metaData.deviceType,
		userData.phone,
		userData.sessionId,
		votesData.endTime,
		votesData.startTime,
	])

	return (
		<>
			{transition((style, item) =>
				item ? (
					<animated.div style={style}>
						<MaxWidth>
							<Main>
								<CountDownTimer
									seconds={60}
									size={90}
									strokeBgColor="white"
									strokeColor="#65FFAC"
									strokeWidth={6}
									textColor="white"
									style="-50px"
									timerStatus={timerStatus}
									handleTimerStatus={handleTimer}
								/>
								<VoteWrapper>
									<Question>
										{selectedLanguage === 'mr'
											? votesData.questionData.alternateQuestionText
											: votesData.questionData.question}
									</Question>
									<OptionsWrapper>
										{votesData.questionData.options.map(
											(item, index) => {
												return (
													<div
														style={{ position: 'relative' }}
														key={index}
													>
														<HexParent
															key={item.optionId}
															onClick={() =>
																handleSelectedOption(item)
															}
														>
															<HexButton
																key={item.optionId}
																isSelected={
																	selectedOption.optionId ===
																	item.optionId
																}
															>
																<HexButtonText>
																	{selectedLanguage === 'mr'
																		? item.alternateOptionText
																		: item.option}
																</HexButtonText>
															</HexButton>
														</HexParent>
														<Line />
													</div>
												)
											}
										)}
									</OptionsWrapper>
								</VoteWrapper>
								<Footer
									voteSelected={selectedOption.option ? true : false}
									isLoading={false}
									onSubmit={onSubmit}
								/>

								{/* <ButtonWrap>
									<WrapperButton
										isLoading={false}
										btnText={
											<span>
												{translations.LOCK_OPTION}{' '}
												<ArrowImg src={arrowLogo} />
											</span>
										}
										buttonClickHandler={onSubmit}
										isEnabled={selectedOption.option ? true : false}
										height={'48px'}
										width={'50%'}
									/>
								</ButtonWrap> */}
							</Main>
						</MaxWidth>
					</animated.div>
				) : (
					''
				)
			)}
		</>
	)
}

export default Votes
